<div class="password-wrapper">
  <div class="global-icon password-icon" ngclass aria-hidden="true"></div>

  <input
    [(ngModel)]="value"
    (blur)="onTouch()"
    class="password-input"
    [type]="showPassword ? 'text' : 'password'"
    [placeholder]="placeholder"
  />

  <div
    *ngIf="visibilityToggle"
    class="global-icon visibility-toggle"
    
    (click)="showPassword = !showPassword"
    [ngStyle]="{
      '-webkit-mask-image':
        'url(' +
        (showPassword
          ? 'assets/icons/visibility_off.svg'
          : 'assets/icons/visibility-on.svg') +
        ')',
      'mask-image':
        'url(' +
        (showPassword
          ? 'assets/icons/visibility_off.svg'
          : 'assets/icons/visibility-on.svg') +
        ')'
    }"
    aria-label="toggle password visibility"
  ></div>
</div>
